import userApi from "apis/userApi";
import LoadingIcon from "components/loading/LoadingIcon";
import Modal from "components/modal/Modal";
import { FundTransSearchPayload, FundTransferItem, FundTransferType } from "models/fundTransferModel";
import moment from "moment";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import styles from "./account-option.style";
import DatePicker from "components/date-picker/DatePicker";
import { css } from "@emotion/css";
import BetRecord from "components/bet-record/BetRecord";

function FundAccountTransfer() {
    const [fundTypeList, setFunTypeList] = useState<FundTransferType[]>([]);
    const [fundTypeSelect, setFunTypeSelect] = useState<FundTransferType>({} as FundTransferType);
    const [startTime, setStartTime] = useState<Date | null>(new Date(`${moment(new Date()).format('yyyy-MM-DD')} 00:00:00`));
    const [endTime, setEndTime] = useState<Date | null>(new Date(`${moment(new Date()).format('yyyy-MM-DD')} 23:59:59`));
    const [accountList, setAccountList] = useState<FundTransferItem[] | null>(null);
    const [betRecordId, setBetRecordId] = useState<string | null>(null);

    const [loading, setLoading] = useState(false);

    // ma so cuoc
    const [wid, setWid] = useState('');

    // ma so bien dong
    const [fundId, setfundId] = useState('');

    useEffect(() => {
        const initFundTran = async () => {
            try {
                const { data } = await userApi.initAgentZbBean({});
                if(!data.msg) {
                    setFunTypeList(data.typelist);
                    if(data.typelist.length > 0) {
                        setFunTypeSelect(data.typelist[0]);
                    }
                } else {
                    toast.error(data.msg);
                }
            } catch (error) {
                console.log(error);
            }
        }; initFundTran();
    }, []);

    const handleChangeFundType = (values: string) => {
        const fundSelect = fundTypeList.find((item) => item.value === values);
        if(fundSelect) {
            setFunTypeSelect(fundSelect);
        }
    };

    const searchFund = async () => {
        const payload: FundTransSearchPayload = {
            type: fundTypeSelect.value,
            starttime: startTime ? moment(startTime).format('yyyy-MM-DD HH:mm:ss') : '',
            endtime: endTime ? moment(endTime).format('yyyy-MM-DD HH:mm:ss') : '',
            wid,
            id: fundId,
        };
        setLoading(true);
        try {
            const { data } = await userApi.balanceChangeSearch(payload);
            if (!data.msg) {
                const accountData = data.reslist.map((item: FundTransferItem) => ({
                    ...item,
                    showDetail: [1, 5, 8, 9, 830, 850, 890, 13, 3001, 3002, 3003, 4001, 4002].includes(item.opttype),
                    isNote: Number(item.opttype) === 13 && item.remark.trim() !== '',
                }));
                setAccountList(accountData);
            } else {
                toast.error(data.msg);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    const handleCancelBet = (recordId: string) => {};

    return (
        <>
            <div className={`${styles.wrap}`}>
                <h6 className={styles.title}>Biến Động Số Dư</h6>
                <div className={styles.flexbox}>
                    <div className={`${styles.groupInput} ${styles.flex50}`}>
                        <label htmlFor="">Loại Biến Động Số Dư</label>
                        <div className={styles.wrapInput}>
                            <select className="input-common" value={fundTypeSelect.value} onChange={(e) => handleChangeFundType(e.target.value)}>
                                {fundTypeList.map((item, index) => (
                                    <option value={item.value} key={index}>
                                        {item.label}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    <div className={`${stylefun.groupTime} ${styles.flex50}`}>
                        <div className={styles.groupInput} style={{ flex: 1 }}>
                            <label htmlFor="">Thời Gian Từ</label>
                            <div className={styles.wrapInput}>
                                <DatePicker showTime dateSelect={startTime} onSelectDate={(date) => setStartTime(date)} showIcon />
                            </div>
                        </div>
                        <div className={styles.groupInput} style={{ flex: 1 }}>
                            <label htmlFor="">Đến</label>
                            <div className={styles.wrapInput}>
                                <DatePicker showTime dateSelect={endTime} onSelectDate={(date) => setEndTime(date)} showIcon />
                            </div>
                        </div>
                    </div>

                    <div className={`${styles.groupInput} ${styles.flex50}`}>
                        <label htmlFor="">Mã Số Cược</label>
                        <div className={styles.wrapInput}>
                            <input value={wid} onChange={(e) => setWid(e.target.value)} className={`input-common`} type="text" placeholder="Mã số cược" />
                        </div>
                    </div>
                    <div className={`${styles.groupInput} ${styles.flex50}`}>
                        <label htmlFor="">Mã Số Biến Động</label>
                        <div className={styles.wrapInput}>
                            <input value={fundId} onChange={(e) => setfundId(e.target.value)} className={`input-common`} type="text" placeholder="Mã số biến động" />
                        </div>
                    </div>
                </div>
                <div className={`${styles.elmSubmit}`}>
                    <button type="submit" className={`btn-primary ${styles.btnSubmit}`} onClick={searchFund}>
                        Tìm Kiếm
                    </button>
                </div>
                <div className="table-common">
                    {accountList ? (
                        <>
                            {accountList.length > 0 ? (
                                accountList.map((mem) => (
                                    <div className="col-table">
                                        <div className="col-header">
                                            <p>{mem.loginname}</p>
                                            <span>Thời Gian: <strong>{moment(mem.inserttime).format('DD/MM/yyyy HH:mm')}</strong></span>
                                        </div>
                                        <div className="row" key={mem.id}>
                                            <div className="col">
                                                <p>Mã số biến động:</p>
                                                <strong>{mem.id}</strong>
                                            </div>
                                            <div className="col">
                                                <p>Loại Hình:</p>
                                                <strong>{mem.opttypename}</strong>
                                            </div>
                                            <div className="col">
                                                <p>Thu Nhập:</p>
                                                <strong>{new Intl.NumberFormat().format(mem.income)}</strong>
                                            </div>
                                            <div className="col">
                                                <p>Chi:</p>
                                                <strong>{new Intl.NumberFormat().format(mem.pay)}</strong>
                                            </div>
                                            <div className="col">
                                                <p>Số dư trước:</p>
                                                <strong>{new Intl.NumberFormat().format(Number(mem.beforebalance))}</strong>
                                            </div>
                                            <div className="col">
                                                <p>Số dư sau:</p>
                                                <strong>{new Intl.NumberFormat().format(Number(mem.afterbalance))}</strong>
                                            </div>
                                            <div className="col">
                                                <p>Chi tiết:</p>
                                                {mem.showDetail && (
                                                    <span className="btn-detail" style={{ padding: '4px 0', width: '100%', display: 'block' }} onClick={() => setBetRecordId(mem.wid)}>
                                                        Xem
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className="no-data">
                                    <img src={require('assets/images/icons/no-data.png')} alt="" />
                                    <p>Không có dữ liệu</p>
                                </div>
                            )}
                        </>
                    ) : (
                        <div className="no-data"></div>
                    )}
                </div>
            </div>
            <Modal isShow={Boolean(betRecordId)} onClose={() => setBetRecordId(null)} closeClickBackdrop width="60%" maxWidth="900px">
                <BetRecord onClose={() => setBetRecordId(null)} betRecordId={betRecordId} onCancelBet={handleCancelBet} />
            </Modal>
            {loading && <LoadingIcon />}
        </>
    );
}

const stylefun = {
    groupTime: css`
        display: flex;
        gap: 16px;
    `,
};

export default FundAccountTransfer;
